<template>
  <footer>
    <div class="share">
      <h6 class="tiny-responsive">Share</h6>
      <ul class="social-links">
        <li class="social-site">
          <a @click.prevent="shareFacebook"
            class="social-link"><facebook class="icon"/></a>
        </li>
        <li class="social-site">
          <a @click.prevent="shareTwitter"
            target="blank"
            class="social-link"><twitter class="icon"/></a>
        </li>
        <li class="social-site">
          <a @click.prevent="sharePinterest"
            class="social-link pin-it-button"
            count-layout="horizontal"
            data-pin-custom="true"
            target="_blank"><pinterest class="icon"/></a>
        </li>
      </ul>
    </div>
    <div class="corporate-links">
      <h6 class="tiny-responsive">
        <a href="http://www.zesprikiwi.com" target="blank">
          zespri.com
        </a>
      </h6>
    </div>
  </footer>
</template>

<script>
import Facebook from '../../assets/icons/facebook.svg?inline'
import Twitter from '../../assets/icons/twitter.svg?inline'
import Pinterest from '../../assets/icons/pinterest.svg?inline'
import store from '../../store'

export default{
  name: 'navigation-footer',
  components: {
    'facebook': Facebook,
    'twitter': Twitter,
    'pinterest': Pinterest
  },
  methods:{
    shareFacebook(){
      store.commit('shareFacebook')
    },
    shareTwitter(){
      store.commit('shareTwitter')
    },
    sharePinterest(){
      store.commit('sharePinterest')
    }
  }
}
</script>

<style scoped lang="scss">
/** navigation footer **/
@import '../../theme';

.footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  // Extra padding on mobile to account for iOS nav buttons.
  padding-bottom: 106px;

  @include media-breakpoint-up(lg) {
    flex-direction: column;
  }
}

.share {
  margin-bottom: 20px;
}

.tiny-responsive {
  margin: 0;
}

.social-links {
  @include unbulleted-list;
  display: flex;
}

.social-link {
  cursor: pointer;
}

.social-site {
  display: block;
  margin: 7px 6px 0;

  .icon {
    width: 32px;
    height: 32px;
    fill: currentColor;
    border-radius: 5px;
    transition: transform $t-s ease-out;

    &:hover {
      transform: scale(1.2);
    }

    @include media-breakpoint-up(lg) {
      width: 20px;
      height: 20px;
    }
  }
}

</style>
